import { MiniFooterComponent } from '@accounts/ui-common';
import { AccredibleBannerPanelModule } from '@accredible-frontend-v2/components/banner-panel';
import { AccredibleLanguageSelectorComponent } from '@accredible-frontend-v2/components/language-selector';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PanelComponent } from './panel.component';

const MATERIAL_MODULES = [MatIconModule];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AccredibleBannerPanelModule,
    AccredibleLanguageSelectorComponent,
    LazyLoadImageModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
    MiniFooterComponent,
  ],
  exports: [PanelComponent],
  declarations: [PanelComponent],
  providers: [],
})
export class PanelComponentModule {}
